import { render, staticRenderFns } from "./EditSeguroicancelarPage.vue?vue&type=template&id=cbae8440"
import script from "./EditSeguroicancelarPage.vue?vue&type=script&lang=js"
export * from "./EditSeguroicancelarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports